import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction, putAction } from '@/api/manage';
import AssetDetailsModal from "../components/AssetDetailsModal.vue";
export default {
  name: "AssetDetailsModel",
  mixins: [JeecgListMixin],
  components: {
    AssetDetailsModal: AssetDetailsModal
  },
  data: function data() {
    return {
      title: '资产库存详细',
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'assetCode',
        colName: 'asset_code',
        title: '资产编号',
        align: 'center'
      }, {
        dataIndex: 'productName',
        colName: 'productName',
        title: '产品名称',
        align: 'center'
      }, {
        dataIndex: 'insideName',
        colName: 'insideName',
        title: '内部名称',
        align: 'center'
      }, {
        dataIndex: 'model',
        colName: 'model',
        title: '规格型号',
        align: 'center'
      }, {
        dataIndex: 'companyName',
        colName: 'companyName',
        title: '供应商',
        align: 'center'
      }, {
        dataIndex: 'purchaseDate',
        colName: 'purchase_date',
        title: '购置日期',
        align: 'center'
      }, {
        dataIndex: 'danger_dictText',
        colName: 'danger',
        title: '是否危化品',
        align: 'center'
      }, {
        dataIndex: 'surplus',
        colName: 'surplus',
        title: '剩余量(ml)',
        align: 'center'
      }, {
        dataIndex: 'status_dictText',
        colName: 'status',
        title: '资产状态',
        align: 'center'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      addDisabled: false,
      visible: false,
      itemList: {},
      consume: 0,
      outSum: 0,
      assetUrl: '',
      category: '',
      quantum: '',
      type: '',
      url: {
        chemical: "/ea/asset/chemical",
        attachment: "/ea/asset/attachment"
      }
    };
  },
  created: function created() {},
  methods: {
    show: function show(record) {
      this.visible = true;
      this.itemList = record;
      this.selectionRows = [];
      this.selectedRowKeys = [];
      this.queryParam.category = this.itemList.productCategory;
      this.queryParam.productId = this.itemList.productId;
      this.queryParam.status = 1;
      this.consume = this.itemList.consume;
      this.outSum = this.itemList.outSum;
      this.initTableData();
    },
    initTableData: function initTableData(arg) {
      var _this = this;

      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      this.assetUrl = this.url.chemical;
      this.category = params.category;
      this.loading = true;

      if (this.$refs.page) {
        this.$refs.page.disabled = true;
      }

      if (params.category == 22 || params.category == 23) {
        this.assetUrl = this.url.chemical;
      } else if (params.category == 91 || params.category == 92) {
        this.assetUrl = this.url.attachment;
      }

      getAction(this.assetUrl, params).then(function (res) {
        if (res.success) {
          _this.dataSource = res.result.records;
          _this.ipagination.total = res.result.total;
          _this.loadNums++;
        } else {
          _this.$message.warning('系统异常=>' + res.message);
        }
      }).finally(function () {
        _this.loading = false;

        if (_this.$refs.page) {
          _this.$refs.page.disabled = false;
        }
      });
    },
    close: function close() {
      this.$emit('close');
      this.$emit('Refresh');
      this.visible = false;
    },
    searchQuery: function searchQuery() {
      if (this.$refs.page) {
        this.$refs.page.resetPage();
      } else {
        this.loadData(1);
      }
    },
    searchReset: function searchReset() {
      var that = this;
      this.queryParam = {};
      this.queryParam.category = this.itemList.productCategory;
      this.queryParam.productId = this.itemList.productId;
      this.queryParam.status = 1;
      that.loadData(1);
    },
    editAsset: function editAsset() {
      console.log('this.selectedRowKeys', this.selectedRowKeys);

      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
      } else {
        var _that = this;

        var ids = '';

        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }

        this.$confirm({
          title: '确认出库',
          content: '确定出库选中的' + this.selectedRowKeys.length + '条产品的剩余量吗?',
          onOk: function onOk() {
            putAction(_that.assetUrl + "/outAssetWhole/" + ids).then(function (res) {
              if (res.success) {
                _that.$notification.success({
                  message: res.message
                });

                _that.$emit('ok');

                _that.loadData(1);
              } else {
                _that.$notification.warning({
                  message: res.message
                });
              }
            });
          }
        });
      }
    },
    handleDetail: function handleDetail(e) {
      this.$refs.AssetDetailsModal.visible = true;
      this.$refs.AssetDetailsModal.title = '出库：' + e.productName;
      this.$refs.AssetDetailsModal.queryParam.surplus = e.surplus;
      this.$refs.AssetDetailsModal.id = e.id;
      this.$refs.AssetDetailsModal.consume = this.consume;
      this.$refs.AssetDetailsModal.outSum = this.outSum;
      this.$refs.AssetDetailsModal.category = this.category;
    },
    Outbound: function Outbound() {
      var _this2 = this;

      this.initTableData();
      var param = {
        quantum: this.quantum,
        type: this.type,
        productId: this.itemList.productId
      };
      getAction("/ea/asset/om/log/queryWarehousing", param).then(function (res) {
        if (res.success) {
          _this2.consume = res.result.consume;
          _this2.outSum = res.result.outSum;
        } else {
          that.$notification.warning({
            message: res.message
          });
        }
      });
    },
    onSelectChange: function onSelectChange(selectedRowKeys, e) {
      var _this3 = this;

      console.log(e, this.consume, this.outSum);
      console.log('selectedRowKeys', selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
      var sum = 0;
      e.forEach(function (item) {
        sum = sum + item.surplus;
        console.log('sum', sum);

        if (item.surplus > _this3.consume - _this3.outSum) {
          _this3.editDisabled = true;

          if (_this3.editDisabled) {
            throw Error();
          }

          return;
        } else if (sum > _this3.consume - _this3.outSum) {
          _this3.editDisabled = true;

          if (_this3.editDisabled) {
            throw Error();
          }
        } else {
          _this3.editDisabled = false;
          console.log('this.editDisabled', _this3.editDisabled);
        }
      });
    }
  }
};